export interface MePreferencesDreamProfessionDto {
  id?: string;
  name: string | null;
  position_id: string | null;
  order: number;
}

export interface MePreferencesDto {
  distance: number | null;
  city: string | null;
  salary: number | null;
  salary_period: number | null;
  hours_range: number | null;
  education_level: number | null;
  dream_professions: MePreferencesDreamProfessionDto[] | null;
}
